import { Container, ContainerProps } from '@chakra-ui/react';

/**
 * Helper for creating pages that should have a max-height
 *  of the viewport.
 *
 * Disabling page-wide scroll allows us to control scroll lower in the component
 *   hierarchy (only making parts of the pages scrollable), while the navigation
 *   always remains visible
 */
export function FullHeightContainer({ children, ...props }: ContainerProps) {
   return (
      <Container
         display="flex"
         flexDirection="column"
         maxW="100%"
         minHeight={0}
         h="calc(100vh - 50px)"
         p={0}
         {...props}
      >
         {children}
      </Container>
   );
}
